import React, {
	createContext,
	ReactNode,
	useContext,
	useEffect,
	useState,
} from "react";

import { User } from ".";

interface IProps {
	children?: ReactNode;
}

interface IUserContextType {
	user?: User | null;
	users?: User[] | null;
	fetchUsers?: () => any;
}

const UserContext = createContext<IUserContextType>({});

const UserProvider = (props: IProps) => {
	const [user, setUser] = useState(new User());

	const fetchUser = async () => {
		const userData = await fetch("/api/v1/user", {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
		});
		const userJson = await userData.json();
		setUser(User.fromJson(userJson));
	};

	const fetchUsers = async () => {
		const userData = await fetch("/api/v1/users");
		const users = await userData.json();

		return User.fromJsonArray(users);
	};

	useEffect(() => {
		fetchUser();
	}, []);

	// pass the value in provider and return
	return (
		<UserContext.Provider
			value={{
				user,
				fetchUsers,
			}}
		>
			{props.children}
		</UserContext.Provider>
	);
};

export const useUsers = () => {
	return useContext(UserContext);
};

const UserConsumer = UserContext.Consumer;
export { UserProvider, UserConsumer, UserContext };
